// Login.js
import { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "./AuthContext";

export default function Login({ switchToRegister }) {
  const { login } = useContext(AuthContext);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate(); // <-- for redirect after login

  const handleLogin = async () => {
    try {
      setError("");
      await login(email, password); // call AuthContext login
      navigate("/dashboard");       // <-- redirect to Dashboard
    } catch (err) {
      setError(err.response?.data?.error || "Login failed");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <center>
      <h1 style={{ color: 'navy' }}>Login to U2U Job Search Portal</h1>

      <h2 style={{ color: 'black' }}>Use Email: contactus@u2usystems.com and <u>Forum Password</u> to Login</h2>
      <br></br>
      <input
        type="email"
        placeholder="Email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <input
        type="password"
        placeholder="Password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />
      <button onClick={handleLogin}>Login</button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
    <br></br>
      <h4 style={{ color: 'navy' }}>Copyright: https://www.u2uacademy.com </h4>
      <p>
     Don't have an account?{" "}
       <button onClick={switchToRegister}>Register</button>
     </p>
      </center>
    </div>
  );
}